import axios from "axios";
import {getAccessToken, getUserId} from "../shared/utils/SharedAuthentication";


//NavigationBar API call functions
export const getMetaData = async () => {
  try {
    const userId = getUserId();
    const accessToken = getAccessToken();
    const response = await axios.get(`${process.env.REACT_APP_HOST}/user/${userId}/metadata`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching metadata:", error);
    throw error;
  }
};

export const updateMetaData = async (metaData) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/user/${getUserId()}/metadata`,
      metaData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating metadata:', error);
    throw error;
  }
};

//DashBoard API call functions

export const getUsers = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/ums/user/${getUserId()}/system-user?filter=none`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error;
  }
};

export const getRoles = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/ums/super/user-role`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};

export const getRoleDetails = async (roleId) => {
  try {
    const response = await axios.get(
        `${process.env.REACT_APP_HOST}/ums/super/user-role/${roleId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAccessToken()}`,
          },
        }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching role details:', error);
    throw error;
  }
};

export const createRole = async (role) => {
  try {
    const response = await axios.post(
        `${process.env.REACT_APP_HOST}/ums/super/user-role`,
        role,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAccessToken()}`,
          },
        }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating role:', error);
    throw error;
  }
};

export const updateRole = async (roleId, role) => {
  try {
    const response = await axios.put(
        `${process.env.REACT_APP_HOST}/ums/super/user-role/${roleId}`,
        role,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAccessToken()}`,
          },
        }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating role:', error);
    throw error;
  }
};

export const updateUser = async (user) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/ums/user/${getUserId()}/system-user/${user.id}`,
      user,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const deleteUser = async (userId) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_HOST}/ums/user/${userId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

export const resendRegistrationMail = async (value) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_HOST}/resend-key`,
      value,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error resending registration mail:', error);
    throw error;
  }
};

export const resetPassword = async (value) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/ums/${getUserId()}/password?id=${value.id}&password=${value.password}`,
      null,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error resetPassword:', error);
    throw error;
  }
};

export const resetMail = async (value) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_HOST}/request-reset-password`,
      value,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error in resetMail:', error);
    throw error;
  }
};

export const protect = async (id, isProtect) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/ums/${getUserId()}/user-protect/${id}?isProtect=${isProtect}`,
      null,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user protection:', error);
    throw error;
  }
};

export const getUserActionHistory = async (userId, offset, page, order) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/ums/user/${getUserId()}/system-user/${userId}/history?size=${offset}&page=${page}&order=${order}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching user action history:', error);
    throw error;
  }
};

export const getReferencesOfUser = async (userId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/ums/user/${getUserId()}/system-user/${userId}/references`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching references of user:', error);
    throw error;
  }
};

export const getReferencesForRole = async (roleId) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/ums/super/user-role/${roleId}/references`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching references for role:', error);
    throw error;
  }
};

export const updateReferencesOfUser = async (user) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/ums/user/${getUserId()}/system-user/${user.id}/references`,
      user,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating references for user:", error);
    throw error;
  }
};

export const createUser = async (user) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_HOST}/ums/super/user`,
      user,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

export const getUserById = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/ums/user/${getUserId()}/system-user/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching user by ID:", error);
    throw error;
  }
};

//corporate page api call functions
export const getCorporates = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/user/${getUserId()}/corporate`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`, 
        },
      }
    );
    return response.data; 
  } catch (error) {
    console.error('Error fetching corporates:', error);
    throw error; 
  }
};

export const getAccountUsers = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/super/account`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching account users:', error);
    throw error;
  }
};

export const updateCorporate = async (corporate, corporateID) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/user/${getUserId()}/corporate/${corporateID}`,
      corporate,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating corporate:', error);
    throw error;
  }
};

export const deleteCorporate = async (corporateID) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_HOST}/user/${getUserId()}/corporate/${corporateID}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting corporate:', error);
    throw error;
  }
};

export const createCorporate = async (corporate) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_HOST}/user/${getUserId()}/corporate`,
      corporate,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating corporate:', error);
    throw error;
  }
};

//accounts page api call functions
export const deleteAccountUser = async (accountId) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_HOST}/super/account/${accountId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting account user:', error);
    throw error;
  }
};

export const updateAccountUser = async (account, accountId) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/super/account/${accountId}`,
      account,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating account user:', error);
    throw error;
  }
};

export const createAccountUser = async (account) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_HOST}/super/account`,
      account,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating account user:', error);
    throw error;
  }
};

//accounts page api call functions
export const protectedRole = async (id, isProtect) => {
  try {
    console.log(id , isProtect)
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/ums/super/${getUserId()}/user-role-protect/${id}?isProtect=${isProtect}`,
      null,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user protection:', error);
    throw error;
  }
};

export const protectRole = async (id, isProtect) => {
  try {
    const response = await axios.put(
      `${process.env.REACT_APP_HOST}/ums/super/${getUserId()}/user-role-protect/${id}?isProtect=${isProtect}`,
      null,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user protection:', error);
    throw error;
  }
};

export const deleteRole = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_HOST}/ums/super/user-role/${id}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating user protection:', error);
    throw error;
  }
};

// functions of privilages page
export const createPrivilege = async (privilege) => {
  try {
    const response = await axios.post(
        `${process.env.REACT_APP_HOST}/ums/super/user-privilege`,
        privilege,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAccessToken()}`,
          },
        }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating privilege:', error);
    throw error;
  }
};

// Update an existing privilege
export const updatePrivilege = async (privilegeId, privilege) => {
  try {
    const response = await axios.put(
        `${process.env.REACT_APP_HOST}/ums/super/user-privilege/${privilegeId}`,
        privilege,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getAccessToken()}`,
          },
        }
    );
    return response.data;
  } catch (error) {
    console.error('Error updating privilege:', error);
    throw error;
  }
};

export const getPrivileges = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/ums/super/user-privileges`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching privileges:', error);
    throw error;
  }
};

export const deleteUserPrivilege = async (privilegeId) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_HOST}/ums/super/user-privilege/${privilegeId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data; 
  } catch (error) {
    console.error('Error deleting user privilege:', error);
    throw error; 
  }
};

export async function getUserHierarchy(getter, userId) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_HOST}/ums/user/${getter}/user-hierarchy/${userId}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching user hierarchy:', error);
    throw error;
  }
}







 




